<div class="dialog-content">
  @if(isEditMode){
    <h2>Consulter / Modifier un groupe de diffusion</h2>
  } @else {
    <h2>Créer un groupe de diffusion</h2>
  }
    <mat-divider></mat-divider>
    <form [formGroup]="groupeDiffusionForm">
      <div class="libelle-action-section">
        <div class="libelle-section">
          <label>Titre<span class="required-star">*</span> :</label>
          <mat-form-field appearance="outline">
            <mat-label>Titre du groupe</mat-label>
            <input formControlName="titre" matInput>
            @if(groupeDiffusionForm.get('titre')?.hasError('required') && groupeDiffusionForm.get('titre')?.touched){
              <mat-error>
                Champ de saisi obligatoire.
              </mat-error>
            }
          </mat-form-field>
        </div>
  
        @if(isEditMode) {
          <div class="actif-section">
            <mat-button-toggle-group aria-label="Type" formControlName="actif">
              <mat-button-toggle [class.entite-active]="groupeDiffusionForm.controls.actif.value == true"
                                 value="true">
                Actif
              </mat-button-toggle>
              <mat-button-toggle [class.entite-inactive]="groupeDiffusionForm.controls.actif.value == false"
                                 value="false">
                Inactif
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        }
      </div>
  
      <div class="referent-section">
        <label>Référent :</label>
        <div class="fields">
          <mat-form-field appearance="outline">
            <mat-label>Nom du Référent</mat-label>
            <input formControlName="referentNomPrenom" matInput>
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>
  
          <mat-form-field appearance="outline">
            <mat-label>Email du Référent</mat-label>
            <input formControlName="referentEmail" matInput type="email">
            <mat-icon matPrefix>mail</mat-icon>
            @if (groupeDiffusionForm.get('referentEmail')?.touched && groupeDiffusionForm.get('referentEmail')?.hasError('email')) {
              <mat-error>
                Veuillez saisir une adresse e-mail valide.
              </mat-error>
            }
          </mat-form-field>
  
          <mat-form-field appearance="outline">
            <mat-label>Téléphone du Référent</mat-label>
            <input formControlName="referentTelephone" matInput type="tel">
            <mat-icon matPrefix>smartphone</mat-icon>
            @if (groupeDiffusionForm.get('referentTelephone')?.touched && groupeDiffusionForm.get('referentTelephone')?.hasError('pattern')) {
              <mat-error>
                Veuillez saisir un numéro de téléphone valide.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="utilisateurs-section">
        <label>Utilisateurs <span class="required-star">*</span> :</label>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Rechercher un utilisateur</mat-label>
            <input matInput formControlName="utilisateur" [matAutocomplete]="autoUtilisateur" (input)="onUserInput()"placeholder="Rechercher un utilisateur">
            <mat-autocomplete #autoUtilisateur="matAutocomplete" [displayWith]="displayUser">
              @for (user of filteredUsers; track user){
                  <mat-option [value]="user" (onSelectionChange)="onUserSelected($event)">
                      {{ user.surname }} {{ user.givenName }} - {{ user.mail }}
                    </mat-option>
              }
            </mat-autocomplete>
            <button mat-icon-button matSuffix (click)="onAddUser()" aria-label="Ajouter utilisateur">
              <mat-icon>add_circle</mat-icon>
            </button>
          </mat-form-field>
          @if(formSubmitted && selectedUsers.length === 0){
            <div class="error-message">
                Veuillez sélectionner au moins un utilisateur.
            </div>
          }
        </div>
        
      </div>

      
        <div>
          <h3>Utilisateurs ajoutés :</h3>
          <ul>
              @for(user of selectedUsers; track user){
                  <li>
                    <div class="utilisateur-affichage-section">
                      {{ user.surname }} {{ user.givenName }}. Adresse email : {{ user.mail }}. Télephone :  {{ user.mobilePhone }}
                      <button mat-icon-button (click)="onRemoveUser(user)" aria-label="Supprimer l'utilisateur">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </li>
              }
          </ul>
        </div>
      

  
      <mat-divider></mat-divider>
      <div class="message-required">
        <p>Les champs suivis d'un <span class="required-star">*</span> sont obligatoires.</p>
      </div>
      <div class="actions">
        <div class="align">
          <button  mat-raised-button (click)="onClose()">ANNULER</button>
          <button class="button-validate" mat-raised-button (click)="onSubmit()" 
                  [disabled]="groupeDiffusionForm.pristine"
                  [ngClass]="{'disabled-button': groupeDiffusionForm.pristine}">VALIDER</button>
        </div>
      </div>
    </form>
  </div>
  
